import {Item, ItemContent, ItemDescription, ItemTitle} from "@/components/ui/item";

import {getHouseholdAssignedTo} from "../lib/household-assigned-to";
import {formatHouseholdComboboxDescription} from "../lib/household-combobox-display";
import type {Household} from "../types";

export function HouseholdComboboxItem({household}: {household: Household}) {
  const assigneeName = getHouseholdAssignedTo(household.assigned_to)?.name?.trim();

  return (
    <Item size="sm" className="p-0">
      <ItemContent>
        <ItemTitle>
          {household.name}
          {assigneeName ? (
            <span className="text-muted-foreground font-normal"> · {assigneeName}</span>
          ) : null}
        </ItemTitle>
        <ItemDescription className="line-clamp-none text-xs whitespace-normal break-words">
          {formatHouseholdComboboxDescription(household)}
        </ItemDescription>
      </ItemContent>
    </Item>
  );
}
